import apiAddress from "./apiAddress";

const apiProvisionNumber = async ({ token, phoneNumber }) => {
  const mutation = `mutation {
        provisionNewNumber(phoneNumber:"${phoneNumber}"){
          error
          message
          code
          payload
        }
      }`;

  try {
    const result = await fetch(apiAddress(), {
      method: "POST",
      withCredentials: true,
      credentials: "include",
      headers: {
        Authorization: `Bearer ${token}`
      },
      body: JSON.stringify({
        query: mutation
      })
    });
    const json = await result.json();
    return json.data.provisionNewNumber;
  } catch (error) {
    throw error;
  }
};

export default apiProvisionNumber;
